(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collection-slider"] && !Shopify.designMode) return;
  try {
    
    const swiper = new Swiper('.swiper', {
        // Optional parameters
        loop: false,
        slidesPerView: 1.2,
        spaceBetween: 16,
        breakpoints: {
          640: {
            slidesPerView: 2.2,
          },
          768: {
            slidesPerView: 3.2,
          },
          1080: {
            slidesPerView: 4.2
          }
        },
    });
    console.log(swiper);

  } catch(e) { console.error(e); }
})();
})();
